import { OPENROUTESERVICE_URL } from './constants'
import { httpPOST } from './utils'
import { open_route_service_api_key } from './api_keys'
import * as ors_parser from './ors_parser.js'

export const RouteType = {
  REGULAR: 0,
  FAST: 1,
  MOUTAIN: 2,
  WALK: 3,
  HIKE: 4,
};

const OpenRouteServicesRoute = {

  parseResponse(response) {
    const res = JSON.parse(response);
    const features_collection_t = ors_parser.ors(response);

    const summary = res.features[0].properties.summary;
    const properties = res.features[0].properties;
    return new Promise((resolve) => {
      resolve({
        distance: summary.distance,
        duration: summary.duration,
        features: res.features[0],
        features_collection: features_collection_t,
        ascent: properties.ascent,
        descent: properties.descent,
      });
    });
  },

  fetchRoute(wp, type) {
    let url = "";
    // Get desired route type URL:
    switch (type) {
      default:
      case RouteType.REGULAR:
        url = OPENROUTESERVICE_URL + "/v2/directions/cycling-regular/geojson";
        break;
      case RouteType.FAST:
        url = OPENROUTESERVICE_URL + "/v2/directions/cycling-road/geojson";
        break;
      case RouteType.WALK:
        url = OPENROUTESERVICE_URL + "/v2/directions/foot-walking/geojson";
        break;
      case RouteType.HIKE:
        url = OPENROUTESERVICE_URL + "/v2/directions/foot-hiking/geojson";
        break;
    }
    return new Promise((resolve, reject) => {
      httpPOST(url,
        {
          coordinates: wp,
          elevation: "true",
          extra_info: ["steepness"]
        },
        { Authorization: open_route_service_api_key },
      )
        .then(data => this.parseResponse(data))
        .then(route => resolve(route))
        .catch(() => reject("Can't get route for these coordinates"));
    });

  },
};

export const APIRoute = {

  getRoute(waypoints, type = RouteType.REGULAR) {
    // If waypoints only contains one waypoint throw an error: 
    if (waypoints.length <= 1) {
      return new Promise(function (resolve, reject) {
        reject("Cannot compute path with only one way point");
      });
    }

    // Waypoints are expected to be a list of list such as:
    // [[wp1.lon, wp1.lat], [wp2.lon, wp2.lat], ...] 
    return OpenRouteServicesRoute.fetchRoute(waypoints, type);
  },
};